// extracted by mini-css-extract-plugin
module.exports = {"desktopLogo":"header_desktopLogo__Ho9rf","mobileLogo":"header_mobileLogo__r145q","icon":"header_icon__bw7AN"};